export const ORDER_WAY = {
  increase: "increase",
  decrease: "decrease",
  default: "default",
};